import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDBLcu3VcS5T-lzG-ZluEsK7rH7RFuMRCc",
  authDomain: "backupteams-5d57b.firebaseapp.com",
  projectId: "backupteams-5d57b",
  storageBucket: "backupteams-5d57b.firebasestorage.app",
  messagingSenderId: "937369721576",
  appId: "1:937369721576:web:c87d7ff63270ffb139c75d",
  measurementId: "G-KW925BPSYR"
};

const app = initializeApp(firebaseConfig);

// 👇 FIRESTORE (esto faltaba)
const db = getFirestore(app);

// 👇 analytics opcional
let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

// 👇 EXPORTA TODO LO QUE NECESITES
export { db, analytics };